import React, { Component } from 'react'
import GffViewer from './gffviewer'

const styles = {
    container: {
        paddingTop: 5,
        paddingLeft: 15,
        paddingRight: 15,
    },
    background: {
        backgroundColor: 'white',
    },
}

class AppGffManager extends Component {

    render() {
        return (
            <div className="workorder-wrapper" style={styles.background}>
                <div style={styles.container}>
                    <GffViewer />
                </div>
            </div>
        )
    }
}

export default AppGffManager
